
import { concat } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { addPrefix, fetchWithDecoderWithoutErrorPage } from "../CommunicationV2.js";
import { Types_RequestProperties } from "../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { singleton } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { Reader_$ctor_Z3F6BC7B1, Reader__Read_24524716 } from "../fable_modules/Fable.Remoting.MsgPack.1.25.0/Read.fs.js";
import { SearchResponseDto_$reflection } from "../Shared/Search.js";
import { ValidationOnGetRequest } from "../ErrorHandling.js";

export function searchUrl(query) {
    return concat("/api/search?q=", ...window.encodeURIComponent(query));
}

export function fetchSearch(url) {
    return PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (fetchWithDecoderWithoutErrorPage(addPrefix(url), singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response) => {
        const pr = response.arrayBuffer();
        return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), SearchResponseDto_$reflection()));
    }).then((_arg) => {
        const result_1 = _arg;
        return (result_1.tag === 1) ? (Promise.resolve((() => {
            throw new ValidationOnGetRequest(result_1.fields[0]);
        })())) : (Promise.resolve(result_1.fields[0]));
    }))));
}

